export const BASE_URL = "https://api-mobi-parts.varius.rs/api/";
export const API_TOKEN = "token";
export const REFRESH_TOKEN = "refreshToken";
